<template>
	<v-stepper v-model="value" dense>
		<v-stepper-header>
			<Link
				as="v-stepper-step"
				:href="
					$route('tenant.catalogues.edit', {
						tenant: $page.props.tenant.id,
						catalogue: $route().params.catalogue,
					})
				"
				step="1"
				style="cursor: pointer"
			>
				{{ $t("Detail") }}</Link
			>

			<v-divider></v-divider>

			<Link
				as="v-stepper-step"
				:href="
					$route('tenant.catalogues.menu', {
						tenant: $page.props.tenant.id,
						catalogue: $route().params.catalogue,
					})
				"
				step="2"
				style="cursor: pointer"
			>
				{{ $t("Menu") }}
			</Link>

			<v-divider></v-divider>

			<v-stepper-step step="3" style="cursor: pointer">
				{{ $t("Settings") }}
			</v-stepper-step>
		</v-stepper-header>
	</v-stepper>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	name: "CatalogueStepper",

	components: {
		Link,
	},

	props: ["value"],
};
</script>